import(/* webpackMode: "eager", webpackExports: ["CollectionArtwork"] */ "/home/runner/work/MONADATY/MONADATY/components/CollectionArtwork.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Reveal"] */ "/home/runner/work/MONADATY/MONADATY/components/Reveal.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/runner/work/MONADATY/MONADATY/node_modules/next/dist/client/app-dir/link.js");
